import swal from "sweetalert";
import axios from "axios";

const BasicAlert = ({title, body, alertClass}) => {
  return (
    <div className={alertClass}>
      <div className="d-flex flex-column">
        <h4 className="mb-1 text-dark">{title}</h4>
        <span>
                    {body}
                </span>
      </div>
    </div>
  )
}

export default BasicAlert;


export const confirmAlert = (message, successCb, buttons) => {
  swal({
    title: "Are you sure?",
    text: message,
    icon: "warning",
    buttons: buttons ? buttons : true,
    dangerMode: true,
    confirm: {
      text: "Yes",
      value: true,
      visible: true,
      className: "",
      closeModal: true
    }
  }).then((result) => {
    if (result) {
      successCb();
    }
  });
}

export const errorAlert = (message) => {
  swal({
    text: message,
    icon: "error",
  });
}